/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

import CountryCallingCode from './CountryCallingCode';

const chance = new Chance();

export default () => ({
  firstName: chance.first(),
  lastName: chance.last(),
  phoneNumber: chance.phone({ formatted: false }),
  countryCallingCode: CountryCallingCode,
  defaultCountryCallingCode: {
    id: '1',
    description: 'Australia (+61)',
    countryCallingCode: '+61',
  },
});
